import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateCourseTypeDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'position',
    'isDefaultFilter',
    'isIgnored',
    'isExcludedFromSearch',
    'rearrangementScore',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateCourseTypeDetailsArgs
